import React, { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { api, apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import SwissBadge from "@/components/SwissBadge";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 8) {
      toast.error("Passwort muss mindestens 8 Zeichen haben");
      return;
    }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: password });
      toast.success("Passwort aktualisiert. Bitte anmelden.");
      navigate("/login");
    } catch (e) {
      toast.error(apiError(e, "Zurücksetzen fehlgeschlagen"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-white flex items-center justify-center p-8" data-testid="reset-password-page">
      <div className="w-full max-w-md space-y-6">
        <div className="flex items-center" data-testid="reset-brand">
          <img src="/easy-gutachter-logo.png" alt="Easy Gutachter" className="h-20 w-auto select-none" draggable={false} />
        </div>
        <h1 className="font-display text-3xl font-bold tracking-tight">Neues Passwort</h1>
        {!token ? (
          <div className="text-sm text-rose-600">Ungültiger oder fehlender Token.</div>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <div>
              <Label htmlFor="password">Neues Passwort (min. 8 Zeichen)</Label>
              <Input id="password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1.5" data-testid="reset-password-input" />
            </div>
            <Button type="submit" className="w-full brand-gradient-bg text-white" disabled={loading} data-testid="reset-submit-btn">
              {loading ? <Loader2 className="h-4 w-4 mr-2 animate-spin" /> : null}
              Passwort speichern
            </Button>
          </form>
        )}
        <div className="text-sm text-center"><Link to="/login" className="text-[#12A9E8] hover:underline">Zum Login</Link></div>
        <div className="flex justify-center pt-2">
          <SwissBadge />
        </div>
      </div>
    </div>
  );
}
